export function requestFullscreen(elem) {
    if (elem.requestFullscreen) {
        elem.requestFullscreen()
    } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen()
    } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen()
    } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen()
    }
}

export function closeFullscreen() {
    const doc = document as any
    if (doc.exitFullscreen) {
        doc.exitFullscreen()
    } else if (doc.mozCancelFullScreen) {
        /* Firefox */
        doc.mozCancelFullScreen()
    } else if (doc.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        doc.webkitExitFullscreen()
    } else if (doc.msExitFullscreen) {
        /* IE/Edge */
        doc.msExitFullscreen()
    }
}
